import styled from "styled-components";

const styleModal = `
  position: fixed;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: #fff;
  transition: opacity 8.5s ease, visibility 6.5s ease;
  padding: 20px;
  box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset,
    rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: 14px;
`;

export const ModalServiceClassification = styled.div`
  width: 90%;
  margin: 5px;
  height: 700px;
  border-radius: 20px;
  top: 55%;
  ${styleModal}
  
  .loading{
    margin: 25px;
  }

`;

export const ModalForcarFolha = styled.div`
  width: 50%;
  margin: 5px;
  height: 400px;
  border-radius: 8px;
  top: 55%;
  ${styleModal}

  .margin-10{
    margin: 10px;
    text-align: left;

`;

export const ModalEditar = styled.div`
  width: 500px;
  margin: 5px;
  height: 650px;
  border-radius: 8px;
  top: 50%;
  ${styleModal}

  .margin-10{
    margin: 10px;
    text-align: left;

  .title-input{
    margin: 0 0 5px 2px;
  }

  .switch{
    margin: 8px 0 0 0;
  }
`;

export const ModalRemover = styled.div`
  width: 350px;
  margin: 5px;
  height: 250px;
  top: 50%;
  ${styleModal}

  .margin-10{
    margin: 10px;
    text-align: left;

  .title-input{
    margin: 0 0 5px 2px;
  }

  .switch{
    margin: 8px 0 0 0;
  }
`;

export const DisplayFlex = styled.div`
  display: flex;
  width: 100%;
`;

export const Close = styled.div`
  padding: 5px;
  width: 100%;
  text-align: right;

  .font-icon {
    font-size: 35px;
    color: #838383;
    cursor: pointer;
  }
`;

export const Rodape = styled.div`
    text-align: center;
    bottom: 0;
    width: -webkit-fill-available;
`;

export const BtnServices = styled.div`
 padding: 10px 30px;
  border-radius: 8px;
  border: none;
  color: #fff;
  background: #0361a7;
  cursor: pointer;

  &:hover {
    color: #4096ff;
    border: 1px solid #4096ff;
    background: #ffffff;
    transition: 0.2s;
  }

  svg {
    font-size: 18px;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  width: 100vw;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: opacity 0.5s ease, visibility 0.5s ease;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
`;

export const ButtonConfirmForcar = styled.div`
 padding: 10px 30px;
    border-radius: 8px;
    border: none;
    color: #fff;
    background: #0361a7;
    cursor: pointer;
    margin: 0 auto;
    width: 200px;

  &:hover {
    color: #4096ff;
    border: 1px solid #4096ff;
    background: #ffffff;
    transition: 0.2s;
  }
`;